import { myConfig } from './consts.mjs';
import axios from 'axios';
import { useUserStore } from "./stores";

const apiCaller = axios.create({
    baseURL: myConfig.API_END_POINT_URI
});

// Add a request interceptor
apiCaller.interceptors.request.use(
  config => {
    const auth = useUserStore();
    // Modify the config here
    // config.headers['X-CODA-TOKEN'] = myConfig.apiXToken;
    // Retrieve token from local storage or any other source
    if (auth.user?.ut) {
      config.headers["Authorization"] = `Bearer ${auth.user.ut}`;
    }
    return config;
  },
  error => {
    // Handle request error
    return Promise.reject(error);
  }
);

let retData = {
    data: {
        songRegs: [],
    },
    errorData: {
        errorMsg: null
    }
}
export const restapi = {
   confirmOptions() {
    return JSON.stringify(myConfig);
   }, 
   getAllItems() {
      return axios
        .get(myConfig.API_END_POINT_URI)
    },
   async getAllItemsA() {
      await axios
      .get(myConfig.API_END_POINT_URI)
      .then((response) => {
          retData.data.songRegs = response.data;
      })
      .catch((error) => {
          // console.warn(error);
          retData.errorData.errorMsg = 'error retrieving data';
      })
      return retData;
    },
   async getAllSongRegItemsA() {
      await apiCaller
      .get('songreg')
      .then((response) => {
        console.log("response getAllSong - : ", response);
        auth.songRegistrations = response.items;
        retData.data.songRegs = response.items;
      })
      .catch((error) => {
          console.warn(error);
          retData.errorData.errorMsg = 'error retrieving data';
      })
      return retData;
    },
    async getAllUserSongRegsA(keyFob) {
      await apiCaller
      .post('songregu', keyFob)
      .then((response) => {
        console.log("response getAllUser - : ", response);
        const auth = useUserStore();
        auth.songRegistrations = response.data;
        retData.data.songRegs = response.data;
      })
      .catch((error) => {
        console.warn(error);
        retData.errorData.errorMsg = 'error retrieving data';
      })
      return retData;
    },
   async putASongRegItemsA(packedSuitcase) {
    console.log("packed suitcase:", packedSuitcase);
      await apiCaller
      .post('songreg', packedSuitcase)
      .then((response) => {
        console.log("response putASong -: ", response);
        retData.data.songRegs.push("Item added successfully");
        retData.data.songRegs.push(response.item);
      })
      .catch((error) => {
          console.warn(error);
          retData.errorData.errorMsg = 'error retrieving data';
      })
      return retData;
    },
}